import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { RootState } from 'types';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface NetworkErrorProps {
    networkError: boolean;
}

interface NetworkErrorState {
    networkError: boolean;
}

class NetworkError extends React.Component<NetworkErrorProps, NetworkErrorState> {
    constructor(props: NetworkErrorProps) {
        super(props);
        this.state = {
            networkError: false,
        };
    }

    static getDerivedStateFromProps(props: NetworkErrorProps, state: NetworkErrorState) {
        if (props.networkError !== state.networkError) {
            return {
                networkError: props.networkError,
            };
        }
        return null;
    }

    render() {
        return (
            <>
                {this.state.networkError && (
                    <section className="z-100 fixed left-0 top-0 items-center justify-center inset-0 flex fixed-position w-full h-full   bg-white overflow-hidden">
                        <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="relative">
                                <Image src="/static/images/application-error.png" className="mx-auto" alt="error" />
                                <blockquote className="mt-8">
                                    <div className="max-w-3xl mx-auto text-center leading-9 font-sm text-gray-900">
                                        <p className="font-sm font-bold">{translate('Network Error')}</p>
                                        <p className="text-sm">
                                            {translate(
                                                'Oops! Looks like  there is a network issue. Please check your connection'
                                            )}
                                            <span
                                                className="text-primary-activeTextColor mx-1 cursor-pointer"
                                                onClick={() => {
                                                    window.location.reload();
                                                }}
                                            >
                                                {translate('try again')}
                                            </span>
                                            {translate('later')}
                                        </p>
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </section>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    networkError: state.errors.networkError,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NetworkError));
